
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconNavigationMenu = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('rect', { x: '.5', y: '2.5', width: '23', height: '3', rx: '1', ry: '1' }),
    React.createElement('rect', { x: '.5', y: '10.5', width: '23', height: '3', rx: '1', ry: '1' }),
    React.createElement('rect', { x: '.5', y: '18.5', width: '23', height: '3', rx: '1', ry: '1' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M3 7.5a.5.5 0 010-1h18a.5.5 0 010 1H3zM3 12.5a.5.5 0 010-1h18a.5.5 0 010 1H3zM3 17.5a.5.5 0 010-1h18a.5.5 0 010 1H3z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M2.25 18.753a.75.75 0 010-1.5h19.5a.75.75 0 010 1.5H2.25zM2.25 12.753a.75.75 0 010-1.5h19.5a.75.75 0 010 1.5H2.25zM2.25 6.753a.75.75 0 010-1.5h19.5a.75.75 0 010 1.5H2.25z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconNavigationMenu.displayName = 'IconNavigationMenu';
export default IconNavigationMenu;